import { STATUS } from '../../../../global/types/audit'

export const getFailedExamples = (
  auditType: STATUS,
  sectionKey: string,
  page: number,
  count: number = 5,
) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/ai-failed-examples?auditType=${auditType}&sectionKey=${sectionKey}&page=${page}&count=${count}`,
    method: 'GET' as const,
  }
}

export const lookupAudit = (auditObjectId: string) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/lookup/${auditObjectId}`,
    method: 'GET' as const,
  }
}

export const getAIPrompt = (auditType: STATUS, sectionKey: string) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/ai-prompts/${auditType}/${sectionKey}`,
    method: 'GET' as const,
  }
}

export const saveAIPrompt = (body: {
  auditType: STATUS | null
  sectionKey: string | null
  promptText: string
  isEnabled: boolean
  modifiedBy: string
  modelId?: string
}) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/ai-prompts`,
    method: 'POST' as const,
    body,
  }
}

export const evaluatePromptBatch = (body: {
  auditType: STATUS | null
  sectionKey: string | null
  promptText: string
  modelId: string
  passCount: number | ''
  failCount: number | ''
  page: number
}) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/ai-evaluate-prompt-batch`,
    method: 'POST' as const,
    body,
  }
}

export const getExampleImages = (auditType: STATUS, sectionKey: string) => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/example-images?auditType=${auditType}&sectionKey=${sectionKey}`,
    method: 'GET' as const,
  }
}

export const getCleanlinessPromptConfig = () => {
  return {
    url: `${process.env.REACT_APP_ORIGIN}/audit/cleanliness/prompt`,
    method: 'GET' as const,
  }
}
